// Export all services
var cookie_1 = require('./services/cookie');
exports.Cookie = cookie_1.Cookie;
//# sourceMappingURL=services.js.map


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/~/ng2-cookies/src/services.js
// module id = ../../../../ng2-cookies/src/services.js
// module chunks = 3